import { z } from 'zod';

import { createItemEnvelopeSchema } from '@/libs/api';

export const SigninSchema = z.object({
  email: z.string().email({ message: 'Email tidak valid!' }),
  password: z.string().min(4, { message: 'Password minimal 4 karakter!' }),
});

export type SigninPayload = z.infer<typeof SigninSchema>;

const SigninUserApiSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    email: z.string(),
    role: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
  })
  .transform(raw => ({
    id: raw.id,
    name: raw.name,
    email: raw.email,
    role: raw.role,
    createdAt: raw.created_at,
    updatedAt: raw.updated_at,
  }));

const SigninResultSchema = z
  .object({
    access_token: z.string(),
    refresh_token: z.string(),
    token_type: z.string(),
    user: SigninUserApiSchema,
  })
  .transform(raw => ({
    accessToken: raw.access_token,
    refreshToken: raw.refresh_token,
    tokenType: raw.token_type,
    user: raw.user,
  }));

const SigninApiSchema = createItemEnvelopeSchema(SigninResultSchema);

export type SigninDTO = z.infer<typeof SigninApiSchema>;
export type SigninUserDTO = z.infer<typeof SigninUserApiSchema>;

export function toSigninDTO(raw: unknown): SigninDTO {
  return SigninApiSchema.parse(raw);
}
